const HandleProviders = (providers) => (Array.isArray(providers) ? providers.join() : '');

export default HandleProviders;
